import { render, staticRenderFns } from "./SingleRequest.vue?vue&type=template&id=aa43447e"
import script from "./SingleRequest.vue?vue&type=script&lang=js"
export * from "./SingleRequest.vue?vue&type=script&lang=js"
import style0 from "./SingleRequest.vue?vue&type=style&index=0&id=aa43447e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports